<template>
  <div>
    <h1 class="title font-weight-bold mt-2 mb-4">Últimos dados registrados</h1>
    <v-row align="center">
      <v-col cols="12" md="12" class="mt-2">
          <v-icon class="mr-2" size="16" color="white" :style="`height: 24px; width: 24px; border-radius: 50%;background-color: ${basinIconColor};`">{{basinIconName}}</v-icon>
          <span v-if="location" class="pt-1" style="font-size: 16px;">{{location.text}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-card :class="fireRisk ? fireRisk.risk === 'Baixo' ? 'primary darken-1 lowRisk'
          : fireRisk.risk === 'Médio' ? 'primary darken-1 mediumRisk'
          : fireRisk.risk === 'Alto' ? 'primary darken-1 highRisk'
          : fireRisk.risk === 'Muito Alto' ? 'primary darken-1 veryHighRisk'
          : 'primary darken-1 nullRisk': 'primary darken-1'">
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="12">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span v-if="fireRisk" style="color: lightgrey; font-size: small">Atualizado em {{ fireRisk.date }}</span>
              <span v-else style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="#95A1EC" class="mb-2">
              icon-infohidro-fogo-alerta
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Risco de incêndio</v-card-subtitle>
          <v-card-text>
            <v-row v-if="!fireRisk" class="white--text align-start justify-start">
              <v-col class="pa-3" cols="4" sm="3" md="3">
                <h1>Nulo</h1>
              </v-col>
              <v-col cols="8" sm="9" md="9">
                <span>Índice médio da área completa da bacia.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text align-start justify-start">
              <v-col class="pa-3" cols="4" sm="3" md="3">
                <h1 v-if="fireRisk.risk">{{ fireRisk.risk }}</h1>
              </v-col>
              <v-col cols="8" sm="9" md="9">
                <span>Índice médio da área completa da bacia.</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-card :class="hotSpots ? hotSpots.amount >= 1 && hotSpots.amount <= 5 ? 'primary darken-1 oneFiveHotSpot'
          : hotSpots.amount >= 6 && hotSpots.amount <= 10 ? 'primary darken-1 sixTenHotSpot'
          : hotSpots.amount >= 10 && hotSpots.amount <= 15 ? 'primary darken-1 tenFifteenHotSpo'
          : hotSpots.amount > 15 ? 'primary darken-1 fifteenPlusHotSpot'
          : 'primary darken-1 noHotSpot': 'primary darken-1'">
          <v-row class="align-start justify-start ml-2 mr-2">
            <v-col cols="12">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span v-if="!hotSpots" style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
              <span v-else style="color: lightgrey; font-size: small">Atualizado em {{ fomatteDate(hotSpots.updated) }}</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="#95A1EC" class="mb-2">
              icon-infohidro-fogo
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Focos de calor</v-card-subtitle>
          <v-card-text>
            <v-row v-if="!hotSpots" class="white--text">
              <v-col class="pa-3" cols="5">
                <strong class="display-1 font-weight-bold">Nenhum</strong>
                <span class="">foco(s) de calor</span>
              </v-col>
              <v-spacer/>
              <v-col cols="7" class="mt-4">
                <span class="">Quantidade de focos de calor registrados nas últimas 24h.</span>
              </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col class="pa-3" cols="6">
                <strong class="display-1 font-weight-bold" v-if="hotSpots.amount">{{ hotSpots.amount }} </strong>
                <span class="">foco(s) de calor</span>
              </v-col>
              <v-spacer/>
              <v-col cols="6" class="mt-4">
                <span class="">Quantidade de focos de calor registrados nas últimas 24h.</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
    props:{
    location:{
      required: true,
    },
      fireRisk:{
        require:  true
      },
      hotSpots:{
        require:  true
      },
    forecasts:{
      require: true
    },
    basinIcon:{
      type: Object,
      default:() => ({name: 'icon-infohidro-bacia', color: '#69D7A3'})
    },
  },
  name: "LastRecordedData",
  data:()=>({
    //
  }),
  computed:{
    basinIconName(){
      return this.basinIcon.name ? this.basinIcon.name : 'icon-infohidro-bacia';
    },
    basinIconColor(){
      return this.basinIcon.color ? this.basinIcon.color : '#69D7A3';
    },
  },
  methods:{
      fomatteDate(val){
        //console.log('?', val)
        return moment(val, 'YYYY-MM-DDTHH:mm:ssZ').tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm')
      }
  }
}
</script>

<style scoped>
.nullRisk.v-card.v-sheet.theme--dark {
  border-left: 7px solid #038C33 !important;
}
.lowRisk.v-card.v-sheet.theme--dark {
  border-left: 7px solid #2BD925 !important;
}
.mediumRisk.v-card.v-sheet.theme--dark {
  border-left: 7px solid #EBEA00 !important;
}
.highRisk.v-card.v-sheet.theme--dark {
  border-left: 7px solid #F27405 !important;
}
.veryHighRisk.v-card.v-sheet.theme--dark {
  border-left: 7px solid #F20505 !important;
}
.noHotSpot.v-card.v-sheet.theme--dark {
  border-left: 7px solid #97ED8A !important;
}
.oneFiveHotSpot.v-card.v-sheet.theme--dark {
  border-left: 7px solid #F2CC0C !important;
}
.sixTenHotSpot.v-card.v-sheet.theme--dark {
  border-left: 7px solid #FF9F00 !important;
}
.tenFifteenHotSpot.v-card.v-sheet.theme--dark {
  border-left: 7px solid #ff5600 !important;
}
.fifteenPlusHotSpot.v-card.v-sheet.theme--dark {
  border-left: 7px solid #ff3a00 !important;
}
.v-card.v-sheet.theme--dark {
  min-height: 187px;
  min-width: 375px;
  max-height: 200px;
  /*max-width: 750px;*/
}
</style>
